import React from 'react';

import Text from '../Text';

export default function DotSeparator({ className = '' }) {
  return (
    <Text type="span" tone="muted" className={className}>
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="4"
        height="4"
        viewBox="0 0 4 4"
      >
        <circle cx="2" cy="2" r="2" fill="currentColor" />
      </svg>
    </Text>
  );
}
